import { CONNECTION_ID } from "../constants/connection";

export function redirectToSalesforceLoginPage(
  loginUrl: string,
  connectionId: string
) {
  localStorage.setItem(CONNECTION_ID, connectionId);
  window.location.href = loginUrl;
}
